exports.parameters = [
  'headers',
  'params',
  'query',
  'cookies',
  'signedCookies',
  'body',
];
